import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { extendedMutationType } from '../../types';
import ToggleMutationButton from './ToggleMutationButton';

SuspensionButton.propTypes = {
    extendedMutation: extendedMutationType.isRequired,
    confirmationMessage: PropTypes.string.isRequired,
    isSuspended: PropTypes.bool.isRequired,
    extraConfirmationMessage: PropTypes.string,
    disabled: PropTypes.bool,
};

SuspensionButton.defaultProps = {
    extraConfirmationMessage: null,
    disabled: false,
};

function SuspensionButton(props) {
    const {
        extendedMutation,
        confirmationMessage,
        extraConfirmationMessage,
        isSuspended,
        disabled,
    } = props;
    const { t } = useTranslation();
    return (
        <ToggleMutationButton
            className="suspension-button button-bordered-orange"
            confirmationMessage={confirmationMessage}
            extraConfirmationMessage={extraConfirmationMessage}
            extendedMutation={extendedMutation}
            showConfirmationDialog
            icon="user-clock"
            toggleFlag={isSuspended}
            trueFlagText={t('button.unsuspend')}
            falseFlagText={t('button.suspend')}
            disabled={disabled}
        />
    );
}

export default SuspensionButton;
